import CurrentUserProvider from './CurrentUser.provider';

export default CurrentUserProvider;
